// На какой цех человек смотрит.
//
// Один цех — полосы нет вовсе: выбор из одного выглядит как забытая настройка
// и заставляет думать, что где-то есть ещё что-то.
//
// Три режима, и третий — тот, ради которого всё это:
//
//     Все цеха     сложенные цифры завода целиком
//     По цехам     те же цифры столбцами, цех к цеху — «где хуже»
//     <цех>        как раньше, один цех
//
// Второй режим отдельным экраном, а не отдельным дашбордом: два дашборда
// означали бы, что одни и те же числа считаются в двух местах, и рано или
// поздно они разойдутся.
import React, { useState, useEffect } from 'react';
import { branchAPI } from '../api';

export default function BranchSwitch({ mode, onMode }) {
  const [branches, setBranches] = useState([]);

  useEffect(() => {
    branchAPI.getList().then(r => setBranches(r.data || [])).catch(() => {});
  }, []);

  if (branches.length < 2) return null;

  const cur = sessionStorage.getItem('selected_branch') || 'all';

  const pick = (value) => {
    sessionStorage.setItem('selected_branch', value);
    // Перезагрузка, а не пересчёт состояния: цех сидит в перехватчике запросов,
    // и половина экранов уже держит на руках данные прошлого цеха. Дёшево
    // объяснимое обновление честнее наполовину обновившегося экрана.
    if (onMode) onMode(value === 'all' && mode === 'compare' ? 'compare' : 'one');
    window.location.reload();
  };

  const btn = (active) => ({
    background: active ? 'var(--accent)' : 'var(--card)',
    border: '1px solid ' + (active ? 'var(--accent)' : 'var(--border)'),
    borderRadius: 8, color: active ? '#fff' : 'var(--muted)',
    padding: '7px 15px', fontSize: 13, fontWeight: 700, cursor: 'pointer',
    fontFamily: 'inherit', whiteSpace: 'nowrap',
  });

  return (
    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 14,
                  alignItems: 'center' }}>
      <span style={{ color: 'var(--dim)', fontSize: 12, marginRight: 2 }}>Цех:</span>
      <button onClick={() => pick('all')}
        style={btn(cur === 'all' && mode !== 'compare')}>Все цеха</button>
      <button onClick={() => { sessionStorage.setItem('selected_branch', 'all');
                               onMode && onMode('compare'); }}
        style={btn(mode === 'compare')}>По цехам</button>
      {branches.map(b => (
        <button key={b.id} onClick={() => pick(String(b.id))}
          style={btn(cur === String(b.id) && mode !== 'compare')}>
          {b.name}
        </button>
      ))}
    </div>
  );
}
